import { buttonMode } from './button';
import { selectMode } from './select';
import { vueAdminMenuMode } from './vue-admin-menu';

export const modes = {
  'button': buttonMode,
  'select': selectMode,
  'vue-admin-menu': vueAdminMenuMode
}
